import Mekong from "lib/ajax/Mekong";
import { all, call, put, select, takeLeading } from "redux-saga/effects";
import { DownloadItem, setItemStatus, setItemProgress, removeItem } from "./reducers";
import { RootState } from "store";
import { isEmpty } from "lodash";

type MekongItemStatus = 'active' | 'inactive' | 'failed' | 'complete';
type MekongItem = {id: number, status: MekongItemStatus, progress: number, fileUrl?: string};

export default function* sagas() {
	yield all([
		takeLeading('reportDownloader/updateDownloadItems', updateDownloadItems)
	]);
};

function* updateDownloadItems() {
	try {
		const downloadItems: DownloadItem[] = yield select((state: RootState) => state.report.reportDownloader.items);
		const validDownloadItems = downloadItems.filter(di => di.status === 'active');
		if (isEmpty(validDownloadItems)) return;

		const updatedDowndloadItems: MekongItem[] = yield call(Mekong.get, `/v1/report/export/status`, {
			params: { ids: validDownloadItems.map(di => di.jobId) }
		});

		for (const item of updatedDowndloadItems) {
			if (item.status === 'complete') {
				window.open(item.fileUrl);
				yield put(removeItem(item.id));
				break;
			};
			yield put(setItemStatus({ jobId: item.id, status: item.status === 'active' ? 'active' : 'failed' as DownloadItem['status'] }));
			if (item.status !== 'failed') {
				yield put(setItemProgress({ jobId: item.id, progress: item.progress }));
			}
		};
	} catch (error) {
		console.error(error);
	}
}
